import { Action } from '@ngrx/store'

import { ShoppingListItem } from '../../response-box/shopping-list/shopping-list-item'
import { ResponseBoxTabs } from '../../response-box/response-box-tabs'

/**
 * Created by sange on 30/10/2017.
 */
// shopping list
export const ADD_SHOPPING_LIST_ITEM = '[Response] Add shopping list item'
export const ADD_SHOPPING_LIST_ITEM_FILLED = '[Response] Add shopping list item filled'
export const REMOVE_SHOPPING_LIST_ITEM = '[Response] Remove shopping list item'
export const REMOVE_SHOPPING_LIST_ITEM_FILLED = '[Response] Remove shopping list item filled'
export const CREATE_SHOPPING_LIST = '[Response] Create shopping list'
export const CLEAR_SHOPPING_LIST = '[Response] Clear shopping list'
// incomplete msg
export const SET_MSG_INCOMPLETE = '[Response] set msg incomplete'
export const SET_MSG_INCOMPLETE_FILLED = '[Response] set msg incomplete filled'
export const SET_SHOPPING_LIST_MSG = '[Response] shopping list msg'
export const SET_SHOPPING_LIST_MSG_FILLED = '[Response] shopping list msg filled'
// misc
export const SELECT_RESPONSE_TAB = '[Response] select response tab'

export class AddShoppingListItem implements Action {
  readonly type = ADD_SHOPPING_LIST_ITEM

  constructor(public payload: { item: ShoppingListItem }) {
  }
}

export class AddShoppingListItemFilled implements Action {
  readonly type = ADD_SHOPPING_LIST_ITEM_FILLED

  constructor(public payload: { item: ShoppingListItem, conversationId: string }) {
  }
}

export class RemoveShoppingListItem implements Action {
  readonly type = REMOVE_SHOPPING_LIST_ITEM

  constructor(public payload: { item: ShoppingListItem }) {
  }
}

export class RemoveShoppingListItemFilled implements Action {
  readonly type = REMOVE_SHOPPING_LIST_ITEM_FILLED

  constructor(public payload: { item: ShoppingListItem, conversationId: string }) {
  }
}

export class CreateShoppingList implements Action {
  readonly type = CREATE_SHOPPING_LIST

  constructor(public payload: any) {
  }
}

export class ClearShoppingList implements Action {
  readonly type = CLEAR_SHOPPING_LIST

  constructor(public payload: { conversationId: string }) {
  }
}

// incomplete msg
export class SetMsgIncomplete implements Action {
  readonly type = SET_MSG_INCOMPLETE

  constructor(public payload: { messageText: string, append: boolean }) {
  }
}

export class SetMsgIncompleteFilled implements Action {
  readonly type = SET_MSG_INCOMPLETE_FILLED

  constructor(public payload: { messageText: string, conversationId: string, append: boolean }) {
  }
}

export class SetShoppingListMsg implements Action {
  readonly type = SET_SHOPPING_LIST_MSG

  constructor(public payload: { messageText: string }) {
  }
}

export class SetShoppingListMsgFilled implements Action {
  readonly type = SET_SHOPPING_LIST_MSG_FILLED

  constructor(public payload: { conversationId: string, messageText: string }) {
  }
}

// misc
export class SelectResponseTab implements Action {
  readonly type = SELECT_RESPONSE_TAB

  constructor(public payload: { tabIndex: ResponseBoxTabs }) {
  }
}


export type ResponseActions = AddShoppingListItem
  | AddShoppingListItemFilled
  | RemoveShoppingListItem
  | RemoveShoppingListItemFilled
  | CreateShoppingList
  | ClearShoppingList
  | SetMsgIncomplete
  | SetMsgIncompleteFilled
  | SetShoppingListMsg
  | SetShoppingListMsg
  | SetShoppingListMsgFilled
  | SetShoppingListMsgFilled
  | SelectResponseTab



// WEBPACK FOOTER //
// ./src/app/chat/store/actions/response.actions.ts